import { render, staticRenderFns } from "./LearningText.vue?vue&type=template&id=5bc6d363&scoped=true&"
import script from "./LearningText.vue?vue&type=script&lang=js&"
export * from "./LearningText.vue?vue&type=script&lang=js&"
import style0 from "./LearningText.vue?vue&type=style&index=0&id=5bc6d363&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc6d363",
  null
  
)

export default component.exports